import React from 'react'
import { FormWrapper } from './styled'
import PrintingSize from '../printing-size'
import PaperSelector from '../paper-selector'
import PrintingSelector from '../printing-selector'
import CoatingSelector from '../coating-selector'
import SpotUvSelector from '../spot-uv-selector'
import FoilingSelector from '../foiling-selector'
import PlasticWindowSelector from '../plastic-window-selector'
import EmbossingSelector from '../embossing-selector'


const PriceCalculationForm = ({
  measurementUnit,
  formValues,
  setFormValues,
  activeTab,
  disabled,
  setDisabled,
}) => (
  <FormWrapper>
    <PrintingSize
      formValues={formValues}
      setFormValues={setFormValues}
      unit={measurementUnit}
      activeTab={activeTab}
      setDisabled={setDisabled}
    />
    <br/>
    <PaperSelector
      formValues={formValues}
      setFormValues={setFormValues}
      activeTab={activeTab}
      disabled={disabled}
    />
    <br/>
    <PrintingSelector
      formValues={formValues}
      setFormValues={setFormValues}
      activeTab={activeTab}
      disabled={disabled}
    />
    <br/>
    <CoatingSelector
      formValues={formValues}
      setFormValues={setFormValues}
      activeTab={activeTab}
      disabled={disabled}
    />
    <br/>
    <SpotUvSelector
      formValues={formValues}
      setFormValues={setFormValues}
      activeTab={activeTab}
      disabled={disabled}
    />
    <br/>
    <EmbossingSelector
      formValues={formValues}
      setFormValues={setFormValues}
      measurementUnit={measurementUnit}
      activeTab={activeTab}
      disabled={disabled}
    />
    <br/>
    <FoilingSelector
      formValues={formValues}
      setFormValues={setFormValues}
      measurementUnit={measurementUnit}
      activeTab={activeTab}
      disabled={disabled}
    />
    <br/>
    <PlasticWindowSelector
      formValues={formValues}
      setFormValues={setFormValues}
      measurementUnit={measurementUnit}
      activeTab={activeTab}
      disabled={disabled}
    />
  </FormWrapper>
)


export default PriceCalculationForm



// WEBPACK FOOTER //
// ./src/pages/package-page/detail/components/price-calculator-form/index.jsx